module.exports = __webpack_public_path__ + "media/images/service-logo-f9e7a6be36bc48b7e3967b7db76bace0.png";